import { useParams } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { Container, Row, Col, Image, ListGroup, Card, Button } from 'react-bootstrap';
import data from '../data';

function EmployeeScreen() {
     const params = useParams();
     const { slug } = params;
     const employee = data.employees.find((x) => x.slug === slug);

     return (
          <>
               {/* <div className="container-fluid">
                    <div className="row profile-card">
                         <div className="col profile-header">
                              <div className="profile-Image">
                                   <img src={employee.image} alt={employee.name} />
                              </div>

                              <h1 className="employeeName">{employee.name}></h1>
                              <p1 className="employeeTitle">{employee.JobTitle}</p1>
                         </div>
                    </div>
                    <div className="row">
                         <div className=" col profile-body">
                              <p className="description">
                                   <Link className="contact-info" href={employee.phoneNo}>
                                        <BsFillTelephoneFill /> {employee.phoneNo}
                                   </Link>
                              </p>
                              <p className="description">
                                   <Link className="contact-info" href={employee.phoneNo}>
                                        <BsFillTelephoneFill /> {employee.phoneNo}
                                   </Link>
                              </p>
                              <p className="description">
                                   <Link className="contact-info" href={employee.phoneNo}>
                                        <BsFillTelephoneFill /> {employee.phoneNo}
                                   </Link>
                              </p>
                              <p className="description">
                                   <Link className="contact-info" href={employee.phoneNo}>
                                        <BsFillTelephoneFill /> {employee.phoneNo}
                                   </Link>
                              </p>
                              <p className="description">
                                   <Link className="contact-info" href={employee.phoneNo}>
                                        <BsFillTelephoneFill /> {employee.phoneNo}
                                   </Link>
                              </p>
                         </div>
                    </div>
               </div> */}
               <div className="profile-card">
                    <div className="image">
                         <img src={employee.image} alt={employee.name} className="profile-img" />
                    </div>

                    <div className="text-data">
                         <span className="name">{employee.name}</span>
                         <span className="job-title">{employee.JobTitle}</span>
                    </div>

                    <div className="media-buttons">
                         <Link href="#" className="link-button">
                              <i class="bx bxl-facebook"></i>
                         </Link>
                         <p2 className="detail-button">Facebook Account</p2>
                    </div>
                    <div className="media-buttons">
                         <Link href="#" className="link-button">
                              <i class="bx bx-world"></i>
                         </Link>
                         <p2 className="detail-button">Official Website</p2>
                    </div>
                    <div className="media-buttons">
                         <button href="tel:16508623411" className="link-button">
                              <i class="bx bx-phone"></i>
                         </button>
                         <p2 className="detail-button">Work Number</p2>
                    </div>
                    <div className="media-buttons">
                         <Link href="#" className="link-button">
                              <i class="bx bx-envelope"></i>
                         </Link>
                         <p2 className="detail-button">Send me an Email</p2>
                    </div>
                    <div className="media-buttons">
                         <Link href="#" className="link-button">
                              <i class="bx bx-map"></i>
                         </Link>
                         <p2 className="detail-button">Work Location</p2>
                    </div>
               </div>
          </>
     );
}

export default EmployeeScreen;
